import React from 'react'
import { contrastTextColor } from '../../utils/announcementsPermissions'

export default function SectionBadge({ section, className = '' }) {
    if (!section) return null

    return (
        <span
            className={`badge fw-semibold ${className}`}
            style={{ backgroundColor: section.color, color: contrastTextColor(section.color) }}
        >
            {section.name}
        </span>
    )
}
